var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 5.97998C13.7564 5.97998 11.9375 7.79882 11.9375 10.0425C11.9375 12.2861 13.7564 14.105 16 14.105C18.2437 14.105 20.0625 12.2861 20.0625 10.0425C20.0625 7.79882 18.2437 5.97998 16 5.97998Z",
    fill: "#D8EEFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 16.2716C9.42303 16.2716 7.60419 18.0905 7.60419 20.3341V21.6215C7.60419 22.4375 8.19556 23.1332 9.0009 23.2647C13.6363 24.0215 18.3637 24.0215 22.9991 23.2647C23.8045 23.1332 24.3959 22.4375 24.3959 21.6215V20.3341C24.3959 18.0905 22.577 16.2716 20.3334 16.2716H19.9641C19.7642 16.2716 19.5656 16.3033 19.3756 16.3653L18.438 16.6715C16.8538 17.1887 15.1462 17.1887 13.5621 16.6715L12.6244 16.3653C12.4344 16.3033 12.2358 16.2716 12.036 16.2716H11.6667Z",
    fill: "#D8EEFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultProfileIcon);
export default __webpack_public_path__ + "static/media/default-profile-icon.3c44f6eebb1c0f3b5ad9c6e61aea5406.svg";
export { ForwardRef as ReactComponent };